<!--
  Vue wrapper for Bryntum BryntumFullscreenButton
-->

<template>
    <div ref="refElement" />
</template>

<script>

import { Fullscreen, WidgetHelper } from '@bryntum/grid';
import { onBeforeUnmount, onMounted, ref } from 'vue';

export default {

    name : 'BryntumFullscreenButton',

    setup() {
        const instance = ref(null);
        const refElement = ref(null);

        onMounted(() => {
            const button = instance.value = Fullscreen.enabled ? WidgetHelper.createWidget({
                type       : 'button',
                appendTo   : refElement.value,
                icon       : 'b-icon b-icon-fullscreen',
                tooltip    : 'Fullscreen',
                toggleable : true,
                onToggle   : ({ pressed }) => {
                    pressed ? Fullscreen.request(document.documentElement) : Fullscreen.exit();
                }
            }) : null;

            if (button) {
                Fullscreen.onFullscreenChange(() => {
                    button.pressed = Fullscreen.isFullscreen;
                });
            }
        });

        onBeforeUnmount(() => {
            if (instance.value) {
                Fullscreen.onFullscreenChange(null);
                instance.value.destroy();
            }
        });

        return { refElement, instance };
    }

};
</script>
